import type { OnboardingStateAnswer } from '../../../../../music24-api/src/trpc/onboarding.router';

/**
 * The artist of the first-release song: the artist of the checklist (one checklist per artist). An
 * answer of an older server has no `checklistArtist`; then the song actions name the artist, else
 * the first own artist.
 */
export function firstReleaseAccountId(state: OnboardingStateAnswer | undefined): number | null {
  if (state?.checklistArtist !== undefined && state.checklistArtist !== null) {
    return state.checklistArtist.accountId;
  }
  const songAction = state?.checklist?.items.find((item) => 'catalogItemUuid' in item.action)?.action;
  return songAction?.accountId ?? state?.artist?.accountId ?? null;
}
